import { gql } from '@apollo/client'

import { getQueryService } from '../../../../helpers/GraphqlHelpers'
import { InstitutionFragment } from '../../../fragments/InstitutionFragment'
import { InstitutionsQuery } from '../../../generated/graphql'

export const institutions = getQueryService({
  query: gql`
    query institutions {
      institutions {
        ...InstitutionFragment
      }
    }
    ${InstitutionFragment}
  `,
  transformer: (response: InstitutionsQuery): InstitutionsQuery['institutions'] => {
    return response.institutions
  },
})
